import EXTENSION_ENUM from "./extension-enum.json"

export const EXTENSION_DISPLAY_NAMES = {
    [EXTENSION_ENUM.AWS_AUTO_TAGGING]: "AWS auto-tagging",
    [EXTENSION_ENUM.GOOGLE_AUTO_TAGGING]: "Google auto-tagging",
    [EXTENSION_ENUM.IK_REMOVE_BG]: "ImageKit background removal",
    [EXTENSION_ENUM.REMOVE_DOT_BG]: "remove.bg background removal",
    [EXTENSION_ENUM.UPSCALE]: "Upscale image",
    [EXTENSION_ENUM.RETOUCH]: "Retouch image",
    [EXTENSION_ENUM.GENVAR]: "Generate image variants",
    [EXTENSION_ENUM.BG_GENFILL]: "Generative fill",
    [EXTENSION_ENUM.GENIMG]: "Generate image via text prompt",
    [EXTENSION_ENUM.DROP_SHADOW]: "Drop shadow effect",
    [EXTENSION_ENUM.CHANGE_BG]: "Change background",
    [EXTENSION_ENUM.EDIT]: "Edit image",
    [EXTENSION_ENUM.AI_AUTO_DESCRIPTION]: "AI auto-description",
    [EXTENSION_ENUM.AI_TASKS]: "AI tasks",
    [EXTENSION_ENUM.AI_VIDEO_TRANSCRIPTION]: "AI video transcription",
}